import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Chat"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M13.305 22.5L12 21.75L15 16.5H19.5C20.3284 16.5 21 15.8284 21 15V6C21 5.17157 20.3284 4.5 19.5 4.5H4.5C3.67157 4.5 3 5.17157 3 6V15C3 15.8284 3.67157 16.5 4.5 16.5H11.25V18H4.5C2.84315 18 1.5 16.6569 1.5 15V6C1.5 4.34315 2.84315 3 4.5 3H19.5C21.1569 3 22.5 4.34315 22.5 6V15C22.5 16.6569 21.1569 18 19.5 18H15.87L13.305 22.5ZM18 7.5H6V9H18V7.5ZM13.5 12H6V13.5H13.5V12Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Chat.vue"]]);
